import { render } from "./TestMailModal.vue?vue&type=template&id=62f5fa24"
import script from "./TestMailModal.vue?vue&type=script&lang=js"
export * from "./TestMailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__